<template>
    <div class="pcr-group-users">
        <!-- TODO Add this feature -->
        <!-- <div class="tab-contextual-button">
            <el-tooltip placement="top" content="Ajouter dans un établissement" effect="light" :open-delay="300" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                <el-button @click="add">
                    <i class="fa fa-home" aria-hidden="true"></i>
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </el-button>
            </el-tooltip>
        </div> -->

        <el-input placeholder="Recherche" v-model="filterText" class="table-search"></el-input>
        <el-table ref="table" :data="searchFilteredEstablishments" stripe border :default-sort="{prop: 'EstablishmentId', order: 'ascending'}" style="width: 100%" highlight-current-row @row-click="currentChange">
            <el-table-column prop="EstablishmentId" label="Id" sortable width="80px"></el-table-column>
            <el-table-column prop="EstablishmentName" label="Nom" sortable></el-table-column>
            <el-table-column prop="Type" label="Type" sortable></el-table-column>
            <el-table-column prop="Status" label="Statut" sortable></el-table-column>
            <el-table-column label="Groupes" prop="Groups">
                <template slot-scope="scope">
                    <div v-for="g in scope.row.Groups" :key="g.GroupId" style="text-align: center; padding: 4px;">
                        <span class="label" :style="$getComputedColor(g.GroupName)">{{g.GroupName}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="Fonction" prop="Role"></el-table-column>
            <el-table-column label="Autorisation" prop="Rights.GrantLevel" sortable width="140px">
                <template slot-scope="scope">
                    <pcr-grant-level-label :item="scope.row.Rights"></pcr-grant-level-label>
                </template>
            </el-table-column>
            <el-table-column label="Alerte" width="84px">
                <template slot-scope="scope">
                    <div>
                        <el-switch
                            :disabled="scope.row.IsManaging || scope.row.IsPartner"
                            v-model="scope.row.AlertActivated"
                            @change="setAlertActivation($event, scope.row)"
                            on-color="#13ce66"
                            off-color="#ff4949">
                        </el-switch>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="" width="84px" class-name="cell-action" v-if="$currentTreeNode.Rights.GrantLevel >= $grantLevel.administrator">
                <template slot-scope="scope">
                    <el-dropdown trigger="click">
                        <el-button @click.stop>Actions <i class="fa fa-caret-down" aria-hidden="true"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <div @click="editUserRole(scope.row)">Editer la fonction</div>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <div @click="editGrantLevel(scope.row)">Editer l'autorisation</div>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <remove-user-to-group :group-id="scope.row.EstablishmentId" :user-id="nodeId" @on-remove="refresh()" name="cet établissement"></remove-user-to-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <change-user-grant-level-modal :visible.sync="showChangeGrantLevelModal" :zone-id="selectedEstablishmentId" :user-id="nodeId"></change-user-grant-level-modal>
        <change-user-role-modal :visible.sync="showChangeRoleModal" :zone-id="selectedEstablishmentId" :user-id="nodeId"></change-user-role-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import ZoneList from '../cross-components/mixins/zone-list.vue';
export default Vue.component('user-establishment-list', {
    mixins: [ZoneList],
    data() {
        return {
            showChangeRoleModal: false,
            showChangeGrantLevelModal: false,
            selectedEstablishmentId: null
        }
    },
    methods: {
        refresh() {
            if (!this.refreshing) {
                this.refreshing = true;

                this.$http.get('/api/user/' + this.nodeId + '/establishments').then((response) => {
                    this.establishments = response.data;
                    this.refreshing = false;
                });
            }
        },
        currentChange(row, event, column) {
            if(this.$getSelectedText()) 
            {
                this.$refs['table'].setCurrentRow();
                return;
            }

            if(column.label == 'Alerte') return;
            if(column.label == 'Role') return;
            
            this.$router.push({ query: { establishmentId: row.EstablishmentId } });
        },
        editUserRole(row) {
            console.log('editUserRole', row.EstablishmentId)

            this.selectedEstablishmentId = row.EstablishmentId;
            this.showChangeRoleModal = true;
        },
        editGrantLevel(row) {
            console.log('editGrantLevel', row.EstablishmentId)

            this.selectedEstablishmentId = row.EstablishmentId;
            this.showChangeGrantLevelModal = true;
        },
        setAlertActivation($event, row) {
            this.$swal({
                type: 'warning',
                title: 'Changement de l\'alerte',
                html: `Etes-vous sûr de vouloir ` + (row.AlertActivated ? '<b>activer</b>' : '<b>désactiver</b>') + ' les alertes pour cet utilisateur ?',
                showCancelButton: true,
                confirmButtonText: 'Comfimer',
                cancelButtonText: 'Annuler'
            }).then(() => {
                this.$http.post(`/api/user/${this.nodeId}/establishment/alert`, { 
                    establishmentId: row.EstablishmentId, 
                    activated: row.AlertActivated 
                }).then((response) => {
                
                }, this.$defaultSwalApiResponse );
            }, () => row.AlertActivated = !row.AlertActivated);
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/user/user-establishment-list.vue